import { inject } from 'aurelia-framework';
import { Redirect } from 'aurelia-router';
import { Router } from 'aurelia-router';
import $ from 'jquery';
import 'waypoints';

@inject(Router)
export class Visitor {

  constructor(router) {
    this.showView = false;
    this.lightboxView = "login";
    this.router = router;

    this.logo_img = "images/magnfi-logo-small.png";
    this.logo_alt = "Magnfi Logo";

    this.home_url = window.home_url;
    this.site_url = window.site_url;

    this.currentYear = new Date().getFullYear();
    this.supportEmail = window.support_email;
    if(window.whitelabel) {
      this.whitelabel = window.whitelabel;
      this.footer_html = window.footer_html;
      this.logo_img = "api/whitelabel/getFile?file=site_logo";
      this.logo_alt = window.app_name + " Logo";
      this.tutorialUrl = window.tutorial_url;
      this.is_register_disabled = (window.is_register_disabled == 0) ? false : true;
    } else {
        //For Magnfi user
        this.is_register_disabled = (window.is_register_disabled == 0) ? false : true;
    }

    if(window.private_label == 1)
    {
      this.private_label =1;
    }



  }



  attached() {
    this.navMenu.addEventListener("blur", function(e) {
      this.navPanelClass = '';
    }.bind(this));


    console.log(window)
  }



  detached() {
    window.onscroll = null;
  }

  activate() {



  }


  toggleMenu() {
    if (this.navPanelClass) {
      this.navPanelClass = null;
    } else {
      this.navPanelClass = "visible";
      setTimeout(function() {
        this.navMenu.focus();

      }.bind(this), 100);
    }
  }

  setFixBody() {
    if(this.showView)
      $('body').addClass('lock-position');
    else
      $('body').removeClass('lock-position');
  }

  configureRouter(config, router) {
    this.router = router;
   // config.title = window.whitelabel ? window.site_title : 'Magnfi Your Site | Video Testimonials at the Click of a Link';

    config.map([
      { route: [''], name: 'login', moduleId: 'components/visitor/login' },
      { route: ['signup'], name: 'signup', moduleId: 'components/visitor/signup' },
      { route: ['tpLogin'], name: 'signup', moduleId: 'components/visitor/tpLogin' },
      { route: ['tpError'], name: 'tperror', moduleId: 'components/visitor/tpErrorMessages' },
      { route: ['trialExpired'], name: 'trialExpired', moduleId: 'components/visitor/trialExpired' },
      { route: ['signup/:referralId'], name: 'signupAffiliate', moduleId: 'components/visitor/signup' },
      { route: ['inquiry'], name: 'inquiry', moduleId: 'components/visitor/inquiry' },
      { route: ['wlsignup'], name: 'wlsignup', moduleId: 'components/visitor/whiteLabelSignup' },
      { route: ['privacypolicy'], name: 'privacypolicy', moduleId: 'components/visitor/privacyPolicy' },
      { route: ['termsandcondition'], name: 'termsandcondition', moduleId: 'components/visitor/termsCondition' },
      { route: ['testimonialForm/:code'], name: 'testimonialForm', moduleId: 'components/visitor/testimonialForm' }
    ]);

    config.mapUnknownRoutes({ redirect: '' });
  }
}
